<script>
    import { onMount, createEventDispatcher } from 'svelte'

    export let value
    export let field

    const dispatch = createEventDispatcher();

    onMount(() => { if (!value) value = []});
    const handleChange = () => dispatch('change', value);
</script>

{#if value}
    <div class="select">
        {#each field.values as option}
            <label>
                <input type="checkbox" bind:group={value} value={option} on:input={handleChange}>
                {option}
            </label>
        {/each}
    </div>
{/if}

<style>
    label {
        line-height: 30px;
        display: flex;
        align-items: center;
    }

    input {
        margin-bottom: 0;
        margin-right: 10px;
    }
</style>
